module.exports = __webpack_public_path__ + "static/img/limg.d9d9d67e.png";